module.exports = __webpack_public_path__ + "img/receiveRedEnvelopeImage.7a86254c.png";